<template>
    <div>
        <div v-if="pdf_url" class="ratio ratio-1x1">
            <iframe
                class="w-100 border-0"
                :src="pdf_url"
            ></iframe>
        </div>
        
        <div v-else class="alert alert-warning">
            <i class="fas fa-exclamation-triangle me-2"></i>
            <strong>PDF Not Available</strong>
            <p class="mb-0 mt-2">The credit report PDF URL could not be found in the response.</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CreditReport',
    props: {
        credit_data: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        pdf_url() {
            // Handle Experian response structure: response.url_link
            if (this.credit_data?.response?.url_link) {
                return this.validateUrl(this.credit_data.response.url_link);
            }
            
            // Handle alternate structure: result[0].URL_LINK
            if (this.credit_data?.result && Array.isArray(this.credit_data.result) && this.credit_data.result.length > 0) {
                const url = this.credit_data.result[0].URL_LINK || this.credit_data.result[0].url_link;
                return this.validateUrl(url);
            }
            
            // Fallback checks for other possible structures
            const fallbackUrl = this.credit_data?.url_link ||
                   this.credit_data?.URL_LINK ||
                   this.credit_data?.PDF_URL ||
                   this.credit_data?.pdf_url || 
                   this.credit_data?.document_url || 
                   this.credit_data?.url ||
                   null;
            return this.validateUrl(fallbackUrl);
        }
    },
    methods: {
        validateUrl(url) {
            // Return null if URL is empty, not a string, or doesn't start with http
            if (!url || typeof url !== 'string' || !url.startsWith('http')) {
                return null;
            }
            return url;
        }
    }
}
</script>
